export const AppImages = {
  assistantNMS: "https://avatars.githubusercontent.com/u/54021133?s=200",
  kurt: "https://kurtlourens.com/assets/images/KurtAvatar.svg",
  meogi: "./assets/img/meogi.webp",
  nmsHub: "./assets/img/invisible.webp",
  silent: "./assets/img/silent.jpg",
  monkeyMan: "https://avatars.githubusercontent.com/u/8000597?v=4",
  nmsCenter: "./assets/img/nms.center.webp",
};
